import React from 'react';
import { Form, Input } from 'antd';
import { GridLayout } from '../GridLayout';

export const ContractGeneralInfoForm: React.FC = () => {
  return (
    <GridLayout columns="repeat(auto-fit, minmax(300px, 1fr))">
      <Form.Item
        name="contractDate"
        label="Contract Date"
        rules={[{ required: true, message: 'Contract date is required' }]}
      >
        <Input 
          placeholder="e.g., 28 February 2025"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item
        name="buyerRef"
        label="Buyer Reference"
      >
        <Input placeholder="e.g., 51-0214" />
      </Form.Item>

      <Form.Item
        name="sellerRef"
        label="Seller Reference"
      >
        <Input placeholder="e.g., SH1024D" />
      </Form.Item>

      <Form.Item
        name="revisionDate"
        label="Revision Date"
      >
        <Input 
          placeholder="e.g., 05 March 2025"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item
        name="buyerSigned"
        label="Buyer Signed Date"
      >
        <Input 
          placeholder="e.g., 06 March 2025"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item
        name="sellerSigned"
        label="Seller Signed Date"
      >
        <Input 
          placeholder="e.g., 05 March 2025"
          style={{ width: '100%' }}
        />
      </Form.Item>
    </GridLayout>
  );
};